export default "__VITE_ASSET__vqG7CHhK__"